export default [
  {
    path: '/app/history',
    name: 'History',
    component: () => import('@/views/Admin/History/Index.vue'),
    meta: {
      pageTitle: 'Tarihçe',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_HISTORY_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/history/add',
    name: 'HistoryAdd',
    component: () => import('@/views/Admin/History/Add.vue'),
    meta: {
      pageTitle: 'Tarihçe',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/history',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_HISTORY_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/history/edit/:id',
    name: 'HistoryEdit',
    component: () => import('@/views/Admin/History/Edit.vue'),
    meta: {
      pageTitle: 'Tarihçe',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/history',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_HISTORY_EDIT',
      action: 'read',
    },
  },
]
